import axios from '../../plugins/axios';

export const getMonthlyStatesTask = ({commit}, { year, month}) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.get(`/api/business-task-states/year/${year}/month/${month}`, config)
    .then((response) => {
    const businessesMonthlyStatesTask = response.data
    commit('SET_BUSINESSES_MONTHLY_STATES_TASK', { businessesMonthlyStatesTask, skipTimestamp: true })
      return response 
    })
    .catch((error) => error.response );
}

export const updateMonthlyStatesTask = ({commit, state}, {data, year, month}) => {
  commit('INCREMENT_PENDING_UPDATES_TASK');
  
  // Actualización optimista
  const optimisticUpdate = JSON.parse(JSON.stringify(state.businessesMonthlyStatesTask));
  const business = optimisticUpdate.find(b => b.id === data.businessId);
  if (business && business.tasks) {
    const task = business.tasks.find(t => t.id === data.taskId);
    if (task) {
      task.state = data.state;
    }
  }
  
  commit('SET_BUSINESSES_MONTHLY_STATES_TASK', { businessesMonthlyStatesTask: optimisticUpdate });
  
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  
  return axios.put(`/api/business-task-states/year/${year}/month/${month}/businessId/${data.businessId}/taskId/${data.taskId}`, data, config)
    .then((response) => {
      commit('DECREMENT_PENDING_UPDATES_TASK');
      return response;
    })
    .catch((error) => {
      console.error('❌ Error actualizando estado de task, recargando desde servidor...');
      commit('DECREMENT_PENDING_UPDATES_TASK');
      
      axios.get(`/api/business-task-states/year/${year}/month/${month}`, config)
        .then((response) => {
          const businessesMonthlyStatesTask = response.data;
          commit('SET_BUSINESSES_MONTHLY_STATES_TASK', { businessesMonthlyStatesTask, skipTimestamp: true });
        });
      return error.response;
    });
}

